import { useState } from "react";
// import CryptoJS from 'crypto-js';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addUser, setlastLogin } from "../../app/features/counterSlice";
import logo from "../../asstes/asd.png";
import CustomizedSnackbars from "../../components/CustomizedSnackbars";
import "./auth.css";
// import jwt from 'jsonwebtoken';
// import crypto from 'crypto-browserify';
import validator from "validator";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  CircularProgress,
  CssBaseline,
  IconButton,
  InputAdornment,
} from "@mui/material";
import cogoToast from "cogo-toast";
import { UploadApi } from "../../constants/Constants";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      style={{ margin: "0px" }}
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="#00b8ff" href="https://www.dcmcloud.com/" target="_blank">
        DCMCloud
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

const Auth2 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [mail, setmail] = useState("");
  const [passwords, setpasswords] = useState("");
  const [dates, setdates] = useState("");
  const [severity, setSeverity] = useState("");
  const [loginUser, setLoginUser] = useState("");
  const [Loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { email, pass, date } = useParams();
  //console.log(email, "tokenn");
  //console.log(date, "dateee");
  //console.log(pass, "passss");

  // alert(user1,"user1");
  // alert(user1,"user1");
  // useEffect(() => {
  //   setLoginUser(user1);
  // }, []);
  // useEffect(() => {
  //   if (token) {
  //     const secretKey = 'your-secret-key'; // Use the same key as for encryption

  //     try {
  //       // Replace URL-safe characters before decryption
  //       // const cleanedToken = "token.replace(/\-/g, '+').replace(/_/g, '/')";

  //       const bytes = CryptoJS.AES.decrypt(token, secretKey);
  //       if (bytes) {
  //         const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  //         //console.log('Decrypted Data:', decryptedData);

  //         // Check if the decrypted data is not empty
  //         if (decryptedData) {
  //           const [email, pass, date] = decryptedData.split('*');
  //           //console.log('Decrypted Email:', email);
  //           //console.log('Decrypted Password:', pass);
  //           //console.log('Decrypted Date:', date);
  //         } else {
  //           //console.log("Decryption produced an empty result. Check the encrypted data format.");
  //           // //console.log('Cleaned Token:', cleanedToken);
  //           //console.log('Decrypted Data:', decryptedData);
  //         }

  //       } else {
  //         //console.log("Decryption failed. Check your key or encrypted data.");
  //       }
  //     } catch (error) {
  //       console.error("Decryption error:", error);
  //     }
  //   }
  // }, [token]);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const data2 = new FormData(e.currentTarget);
    const email = data2.get("email");
    const password = data2.get("password");
    if (email == "") {
      setLoading(false);
      cogoToast.error("Email Invalid", { position: "bottom-right" });
    } else if (!validator.isEmail(email)) {
      cogoToast.error("Email Not Valid", { position: "bottom-right" });
      setLoading(false);
    } else if (password == "") {
      cogoToast.error("Password Invalid", { position: "bottom-right" });
      setLoading(false);
    } else {
      //console.log("api hit successfull");
      var data = {
        email: email,
        password: password,
      };

      var requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      };
      try {
        const hello = await fetch(`${UploadApi}/user/sign-in`, requestOptions);
        const resp = await hello.json();
        //console.log(resp);
        setLoading(false);

        if (resp.success == "true") {
          //console.log("resp.success",resp);
          navigate("/");
          dispatch(addUser({ email: resp?.data?.email, id: resp?.data?._id }));
          dispatch(setlastLogin(resp?.previousLogin));
          // history.push('/')
          // alert("/")
          cogoToast.success("Login Succesfully", { position: "bottom-right" });

          // localStorage.setItem('studentToken', result.token);
          localStorage.setItem("userData", JSON.stringify(resp.data));
          localStorage.setItem("token", resp.token);

          localStorage.setItem("jkbnm", "nfjsdngj");
        } else {
          setLoading(false);
          cogoToast.error("Login Failed", { position: "bottom-right" });
          // setTimeout(() => {}, 1000);
        }
      } catch (error) {
        cogoToast.error("Login Failed", { position: "bottom-right" });
        setLoading(false);
      }
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  //console.log(showPassword,"showPassword");

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxHeight="xs" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // border:"1px solid red",
            padding: "25px 15px",
            borderRadius: "8px",
          }}
          className="boxShadow flex justify-center items-center"
        >
          {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                    </Avatar> */}
          <img src={logo} width="200px" />
          {/* <Typography component="h1" variant="h5">
                        Sign in
                    </Typography> */}
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email/ID"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              id="password"
              autoComplete="current-password"
              sx={{ backgroundColor: "#E8F0FE", borderRadius: 1 }}
              InputProps={{
                sx: { backgroundColor: "inherit", borderRadius: 1 },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleTogglePassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {/* <FormControlLabel
                            control={<Checkbox value="remember" color="primary" />}
                            label="Remember me"
                        /> */}
            {/* <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              style={{
                height:"50px",
                background: "#5582c3",
                padding: "8.5px 6px",
                fontSize: "inherit",

              }}
            >
             {Loading ?<Loader/>:" Sign In"}
            </Button> */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              style={{
                height: "50px",
                background: "#5582c3",
                padding: "8.5px 6px",
                fontSize: "inherit",
                outline: "none", // Remove the black border when clicked
              }}
              // onClick={handleClick}
            >
              {Loading ? (
                <CircularProgress
                  color={"inherit"}
                  style={{ height: "25px", width: "25px" }}
                />
              ) : (
                "Sign In"
              )}
            </Button>
            {/* <Grid container>
                            <Grid item xs>
                                <Link href="#" variant="body2">
                                    Forgot password?
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link href="#" variant="body2">
                                    {"Don't have an account? Sign Up"}
                                </Link>
                                </Grid>
                            </Grid> */}
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Box>
      </Container>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </ThemeProvider>
  );
};

export default Auth2;
